// Interface for raw subject data
export interface RawSubjectData {
  id: number | string;
  subject_code?: string;
  name: string;
  color?: string;
  allowedRooms?: string[]; // Legacy field name
  associatedRooms?: Array<{id: number; name: string}> | string[]; // New backend format or array of room names
  institution_id?: number;
  createdAt?: string;
  updatedAt?: string;
}

class Subject {
  id: string;
  subjectCode?: string;
  name: string;
  color?: string;
  allowedRooms?: string[];
  institutionId?: number;
  createdAt?: string;
  updatedAt?: string;

  constructor(data: RawSubjectData) {
    this.id = String(data.id);
    this.subjectCode = data.subject_code;
    this.name = data.name;
    this.color = data.color;
    
    // Handle both legacy allowedRooms and new associatedRooms formats
    if (data.associatedRooms) {
      if (Array.isArray(data.associatedRooms) && data.associatedRooms.length > 0) {
        // Check if it's the new backend format (array of objects) or array of strings
        if (typeof data.associatedRooms[0] === 'object' && data.associatedRooms[0].name) {
          this.allowedRooms = data.associatedRooms.map((room: any) => room.name);
        } else {
          this.allowedRooms = data.associatedRooms as string[];
        }
      } else {
        this.allowedRooms = [];
      }
    } else {
      this.allowedRooms = data.allowedRooms || [];
    }
    
    this.institutionId = data.institution_id;
    this.createdAt = data.createdAt;
    this.updatedAt = data.updatedAt;
  }

  /**
   * Converts Subject instance to API format for updates
   * @returns {Object} - Subject data in API format
   */
  toApiFormat() {
    return {
      subject_code: this.subjectCode,
      name: this.name,
      color: this.color,
      associatedRooms: this.allowedRooms || []
    };
  }

  static fromMockData(mockSubjects: any[]): Subject[] {
    return mockSubjects.map(subject => new Subject({
      id: subject.id,
      subject_code: subject.code,
      name: subject.name,
      color: subject.color,
      allowedRooms: subject.allowedRooms
    }));
  }

  static fromRawDataArray(rawData: RawSubjectData[]): Subject[] {
    return rawData.map(data => new Subject(data));
  }
}

export default Subject; 